import { DashboardCard } from '@/common/dashboard/DashboardCard'
import { StatCard } from '@/common/dashboard/StatCard'
import { Spacer } from '@/common/layout/SpacerLayout'
import { useRsrc } from '@/common/rsrc/RsrcContext'
import { useEffect, useState } from 'react'
import { AbvSapReconOpenMonthProgressChart } from './charts/AbvSapReconOpenMonthProgressChart'

export const AbvDiscrepancyHighlightCards = ({ prodIds, channelIds }) => {

  const rsrc = useRsrc();
  const [data, setData] = useState();

  useEffect(() => {
    const params = { prodIds, channelIds };
    rsrc.data('gtn', 'RECON_OPEN_PERIOD_DISCREPANCIES_DATA_PLUGIN', params).then(res => {
      setData(res);
    });
  }, [prodIds, channelIds]);

  return (
    <Spacer>
      <Spacer vertical>
        <StatCard
          title="Total Discrepancy Dollars"
          flex={1}
          amt={data?.totalDiscrepancyAmt}
          pctChange={data?.pctChange}
          vsLabel="3 month average"
        />
        <StatCard
          title="Unresolved Discrepancy Dollars"
          flex={1}
          amt={data?.outstandingDiscrepancyAmt}
        />
      </Spacer>

      <DashboardCard flex={1}>
        <AbvSapReconOpenMonthProgressChart data={data} />
      </DashboardCard>
    </Spacer>
  )

}